import React from "react";
import Typography from "@material-ui/core/Typography";
import { Card } from "primereact/card";
const Showcase = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Showcase
      </Typography>
      <Typography paragraph variant="h5">
        Invifo platform solutions for all major industry.
      </Typography>
      <Typography paragraph variant="body1">
        Invifo industry solutions are helping solve complex business challenges,
        and digitally transforming companies worldwide in a simple way. We help
        companies across multiple industries run better by redefining ERP with
        less complexity and creating networks of intelligent enterprises. With
        our experience, we help you accelerate digital transformation to achieve
        transparency, resiliency, profitability, and sustainability across the
        business process. Say "No" to complex ERP, sometimes something simple is
        more profitable.
      </Typography>
      <div className="row">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card className="mt-3">
            <Typography variant="h6">Aerospace</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Agribusiness</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Automotive</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Banking</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Logistic</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Chemicals</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Consumer Products</Typography>
          </Card>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card className="mt-3">
            <Typography variant="h6">Engineering</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Fashion</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Healthcare</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Industrial Manufacturing</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Insurance</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Media</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Mining</Typography>
          </Card>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card className="mt-3">
            <Typography variant="h6">Oil, Gas, and Energy</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Travel</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Professional Services</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Real Estate</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Retail</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Telecommunications</Typography>
          </Card>
          <Card className="mt-3">
            <Typography variant="h6">Utilities</Typography>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Showcase;
